import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
} from "@angular/core";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "embryo-LighteningDeals",
    templateUrl: "./LighteningDeals.component.html",
    styleUrls: ["./LighteningDeals.component.scss"],
})
export class LighteningDealsComponent implements OnInit {
    images = [
        "../../../assets/images/shoe1.jpeg",
        "../../../assets/images/shoe2.jpeg",
        "../../../assets/images/shoe3.jpeg",
        "../../../assets/images/shoe3.jpeg",
    ];

    @Input() homePageDataSectionsSilders: any;
    @Input("fullData") fullData: any;
    sliderDataTest: any;
    ChoosenOptionalImage: any;
    showMainImage: boolean = false;

    //  @Output() addToCart: EventEmitter<any> = new EventEmitter();

    //  @Output() addToWishlist: EventEmitter<any> = new EventEmitter();

    @Input() lighteningDeals: any;

    @ViewChild("aa", { static: false }) aa!: ElementRef;
    lang: string = "";

    constructor(
        public embryoService: EmbryoService,
        private translate: TranslateService
    ) {
        embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
            translate.setDefaultLang(lang);
        });
    }

    ngOnInit() {
        this.lang = localStorage.getItem("lang") || "en";
        this.showMainImage = true;
        this.homePageDataSectionsSilders;
    }

    setImage(img: any) {
        this.showMainImage = false;
        this.ChoosenOptionalImage = img;
        // this.aa.nativeElement.src = '../../../assets/images/shoe1.jpeg';
        //  this.aa.nativeElement.style = '900';
    }

    //   public addToCartProduct(value: any) {
    //     this.addToCart.emit(value);
    //  }

    //  public productAddToWishlist(value: any) {
    //     this.addToWishlist.emit(value);
    //  }

    public addToCart(value: any) {
        this.embryoService.addToCartGuest(value);
    }

    public addToWishlist(value: any) {
        this.embryoService.addToWishlist(value);
    }
}
